var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxCollectingTreasure01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-collecting-treasure-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.41,2H6.59L.67,7.91,12,22.64,23.33,7.91ZM12,6.59,9.41,4h5.18ZM14.41,9h.24L12,17.6,9.35,9h5.06ZM9.59,7H4.41L7,4.41ZM7.26,9l2.15,7L4,9Zm9.48,0H20l-5.38,7ZM14.41,7,17,4.41,19.59,7Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxCollectingTreasure01);
export default __webpack_public_path__ + "static/media/24px-collecting-treasure-01.d3533f34b9e98725f3c8c8982cce59ab.svg";
export { ForwardRef as ReactComponent };